import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="legal">
      <div className="legal-inner">
        <span className="legal-label">// Legal</span>
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-updated">Last updated: June 2026</p>
        <Link to="/" className="legal-back">← Back to Home</Link>

        <div className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            aXtion Technologies ("aXtion", "we", "us", or "our") respects your privacy and is
            committed to protecting the personal information you share with us through our
            website, products, and services, including aXtion Telemed, aXtion EHR Systems,
            aXtion Students Portal, Fintech Integration, and Enterprise Software Solutions.
          </p>
          <p>
            This Privacy Policy explains what information we collect, how we use it, and the
            choices you have regarding your information.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>Contact details such as your name, email address, phone number, and company name when you submit a form on our website.</li>
            <li>Information you provide when requesting a consultation or demo of our services.</li>
            <li>Technical data such as IP address, browser type, and pages visited, collected automatically through standard web analytics.</li>
            <li>Health, academic, or financial information processed on behalf of our clients through aXtion Telemed, aXtion EHR Systems, aXtion Students Portal, and Fintech Integration — handled in accordance with applicable regulations such as HIPAA, FERPA, and PCI-DSS.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To respond to inquiries submitted through our contact form.</li>
            <li>To provide, maintain, and improve our products and services.</li>
            <li>To communicate updates, security notices, and support information.</li>
            <li>To comply with legal, regulatory, and contractual obligations.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Data Security</h2>
          <p>
            We implement administrative, technical, and physical safeguards designed to protect
            personal information from unauthorized access, disclosure, alteration, and
            destruction. Platforms handling protected health information are designed to operate
            in compliance with HIPAA security and privacy standards.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell your personal information. We may share information with trusted
            service providers who assist us in operating our website and delivering our
            services, subject to confidentiality obligations, or where required by law.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Your Rights</h2>
          <p>
            Depending on your location, you may have the right to access, correct, or request
            deletion of your personal information. To exercise these rights, please contact us
            using the information below.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or how your information is handled,
            please contact us at{' '}
            <a href="mailto:info@axtiontechnologies.com">info@axtiontechnologies.com</a> or call{' '}
            <a href="tel:+17035777500">+1 703-577-7500</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
